var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesIndentV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.1667H4.66667C4.22464 18.1667 3.80072 17.9911 3.48816 17.6785C3.17559 17.366 3 16.942 3 16.5V3.66667C3 3.22464 3.17559 2.80072 3.48816 2.48816C3.80072 2.17559 4.22464 2 4.66667 2H12.1667L16.3333 6.16667V9.67784",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 2V5.33333C11.332 5.77536 11.5076 6.19928 11.8202 6.51184C12.1327 6.82441 12.5567 7 12.9987 7H16.332",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0238 11.4156C10.0005 11.3607 9.99413 11.3002 10.0055 11.2418C10.0169 11.1833 10.0454 11.1296 10.0875 11.0875C10.1296 11.0454 10.1833 11.0169 10.2418 11.0055C10.3002 10.9941 10.3607 11.0005 10.4156 11.0238L17.0156 13.7238C17.0743 13.7479 17.1239 13.79 17.1572 13.844C17.1904 13.8981 17.2057 13.9613 17.2008 14.0246C17.1958 14.0879 17.171 14.148 17.1297 14.1963C17.0884 14.2445 17.0329 14.2785 16.9712 14.2932L14.3618 14.9178C14.254 14.9435 14.1555 14.9985 14.0772 15.0768C13.9988 15.155 13.9436 15.2535 13.9178 15.3612L13.2938 17.9712C13.2792 18.0331 13.2453 18.0889 13.197 18.1303C13.1487 18.1718 13.0885 18.1968 13.025 18.2017C12.9615 18.2067 12.8981 18.1913 12.844 18.1578C12.7898 18.1244 12.7477 18.0745 12.7238 18.0156L10.0238 11.4156Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIndentV2);
export default __webpack_public_path__ + "static/media/salesIndentV2.c979a4b49d03736b9ff94041aee4b9ed.svg";
export { ForwardRef as ReactComponent };